// extracted by mini-css-extract-plugin
export default {"modalSize":"UserMigrationTicketsModal_modalSize__9G+xG"};